<empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>

<!-- MIGAS DE PAN Y TÍTULO -->
<div class="bg-second-migas">
  <div class="container mt-cab-fixed">
    <div class="pre-content">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">Acuerdo Indirecto</li>
          <li class="breadcrumb-item active">
            <a href="#/managers-agreements/indirect-agreement-search">Búsqueda de Acuerdos</a>
          </li>
          <li class="breadcrumb-item active">Detalle de Acuerdo</li>
        </ol>
      </nav>
      <div class="d-flex content-title">
        <div class="d-flex">
        <h2 class="title-pag">Detalle de Acuerdo Indirecto {{ acuerdoInfo?.id }}</h2>
            <div *ngIf="datosCargados" class="custom-container" [ngStyle]="styleEstado" style="font-weight: 600;">
            <div>
              <span style="font-size: larger; padding-top: 5px; display: flex;">
                <mat-icon class="show-icon" [ngStyle]="{'color': styleEstado.color + ' !important'}">{{ iconEstado }}</mat-icon>
              </span>
            </div>
            <div>
              <span class="info-texto-estado" [ngStyle]="{'color': styleEstado.color + ' !important'}" style="font-weight: 600; display: block;">
                {{textoEstado}}</span>
            </div>
            <div *ngIf="this.acuerdoIndirectoInfo?.estado?.infoAdicional" style="padding-top: 8px;">
              <div class="tool-help" matTooltip={{this.acuerdoIndirectoInfo?.estado?.infoAdicional}}>
                <span>i</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- FIN MIGAS DE PAN Y TÍTULO -->

<!-- CONTENIDO - FICHA -->
<div class="bg-second-table-info pt-0 pb-5">
  <div class="container">
    <div class="card-ficha">
      <div class="card-body">
        <div class="ficha-2col">
          <div class="col-tab-list">
            <ul class="list">
              <li [ngClass]="{'active': selectedMenu === 1}" (click)="!canAccessContinuarAll(1) ? loadNumMenu(1) : mensajeValidacion()">1. Datos generales</li>
              <li [ngClass]="{'active': selectedMenu === 2}" (click)="!canAccessContinuarAll(1) ? loadNumMenu(2) : mensajeValidacion()">2. Instalaciones de gestión</li>
              <li [ngClass]="{'active': selectedMenu === 3}" (click)="!canAccessContinuarAll(1) ? loadNumMenu(3) : mensajeValidacion()">3. Datos de contacto</li>
              <li [ngClass]="{'active': selectedMenu === 4}" (click)="!canAccessContinuarAll(1) ? loadNumMenu(4) : mensajeValidacion()">4. Domicilio</li>
              <li [ngClass]="{'active': selectedMenu === 5}" (click)="!canAccessContinuarAll(4) ? loadNumMenu(5) : mensajeValidacion()">5. Datos de la autorización</li>
              <li [ngClass]="{'active': selectedMenu === 6}" (click)="!canAccessContinuarAll(5) ? loadNumMenu(6) : mensajeValidacion()">6. Ámbito geográfico del acuerdo</li>
              <li [ngClass]="{'active': selectedMenu === 7}" (click)="!canAccessContinuarAll(5) ? loadNumMenu(7) : mensajeValidacion()" *ngIf="this.acuerdoIndirectoInfo?.estado?.id !== 1 && this.acuerdoIndirectoInfo?.estado?.id !== 2">7. Documentación asociada al acuerdo</li>
              <li [ngClass]="{'active': selectedMenu === 8}" (click)="!canAccessContinuarAll(6) ? loadNumMenu(8) : mensajeValidacion()" *ngIf="this.acuerdoIndirectoInfo.estado.id === 5 || this.acuerdoIndirectoInfo.estado.id === 6" >8. Gestión de poseedores</li>
            </ul>
          </div>

          <!-- 1. DATOS GENERALES -->
          <div *ngIf="selectedMenu === 1" class="col-content">
            <div class="section-header d-flex align-items-center gap-3 mb-4">
              <h3 class="section-title mb-0">Datos generales</h3>
            </div>
            <div *ngIf="datosCargados" class="row form">
              <form [formGroup]="datosGeneralesForm">
                <div class="col-sm flex-grow-1">
                  <label for="tipodoc">Tipo documento <span class="oblig">*</span></label>
                  <mat-form-field appearance="outline" class="custom-mat-form-field-width">
                    <mat-select formControlName="tipoDocumento" (selectionChange)="tipoDocumentoSel($event.value)" id="tipodoc"
                      placeholder="Tipo documento">
                      <mat-option *ngFor="let tipo of tiposDocumento" [value]="tipo.id">
                        {{tipo.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="controlHasError('tipoDocumento', 'required')">Campo obligatorio</mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm flex-grow-1">
                  <label for="numdoc">Documento <span class="oblig">*</span></label>
                  <mat-form-field appearance="outline" class="custom-mat-form-field-width">
                    <input formControlName="codigoDocumento" id="numdoc" placeholder="Documento" matInput type="text"
                      oninput="this.value = this.value.toUpperCase()" maxlength="15">
                    <mat-error *ngIf="controlHasError('codigoDocumento', 'required')">Campo obligatorio</mat-error>
                    <mat-error *ngIf="controlHasError('codigoDocumento', 'pattern')">Formato incorrecto</mat-error>
                    <mat-error *ngIf="controlHasError( 'codigoDocumento', 'maxlength')">Máximo 15 caracteres</mat-error>
                  </mat-form-field>
                </div>
              <div class="col-sm flex-grow-1">
                <label>Razón social <span class="oblig">*</span></label>
                <mat-form-field appearance="outline" class="custom-mat-form-field-width">
                  <input formControlName="razonSocial" id="rsocial" placeholder="Razón Social" matInput type="text" maxlength="150">
                  <mat-error *ngIf="controlHasError('razonSocial', 'required')">Campo obligatorio</mat-error>
                  <mat-error *ngIf="controlHasError( 'razonSocial', 'maxlength')">Máximo 150 caracteres</mat-error>
                </mat-form-field>
              </div>
              <div class="col-sm-6">
                <label>Fecha Firma Acuerdo</label>
                <div class="custom-mat-field">
                  <mat-form-field class="custom-mat-form-field-width" appearance="outline">
                    <input
                      matInput
                      type="text"
                      [value]="acuerdoInfo?.fechaFirmaAcuerdo ? (acuerdoInfo?.fechaFirmaAcuerdo | date:'dd/MM/yyyy') : ''"
                      readonly>
                    <!-- <mat-hint>Se completará con la firma del contrato</mat-hint> -->
                  </mat-form-field>
                </div>
              </div>
              <div class="col-sm-6">
                <label>Fecha Baja Acuerdo</label>
                <div class="custom-mat-field">
                  <mat-form-field class="custom-mat-form-field-width" appearance="outline">
                    <input
                      matInput
                      type="text"
                      [value]="acuerdoInfo?.fechaBajaAcuerdo ? (acuerdoInfo?.fechaBajaAcuerdo | date:'dd/MM/yyyy') : ''"
                      readonly>
                    <!-- <mat-hint>Se completará con la baja del acuerdo</mat-hint> -->
                  </mat-form-field>
                </div>
              </div>
            </form>
            </div>
          </div>
          <!-- 2. GESTORES DEL ACUERDO -->
          <div *ngIf="selectedMenu === 2" class="col-content">
            <managers-agreements-indirect-managers-agreements
              [acuerdoIndirectoInfo]="acuerdoInfo"
              (refrescarAdheridoEvent)="refrescar()">
            </managers-agreements-indirect-managers-agreements> 
          </div>
          <!-- 3. DATOS DE CONTACTO -->
          <div *ngIf="selectedMenu === 3" class="col-content">
            <managers-agreements-detail-contact-data
              [acuerdoIndirectoInfo]="acuerdoInfo"
              [soloLectura]="!canEditGeneralSections()"
              (refrescarAdheridoEvent)="refrescar()">
            </managers-agreements-detail-contact-data>
          </div>

          <!-- 4. DIRECCIONES -->
          <div *ngIf="selectedMenu === 4" class="col-content">
            <managers-agreements-detail-adress
              [acuerdoIndirectoInfo]="acuerdoInfo"
              [soloLectura]="!canEditGeneralSections()"
              (refrescarAdheridoEvent)="refrescar()">
            </managers-agreements-detail-adress>
          </div>

          <!-- 5. AUTORIZACIÓN DE RESIDUOS -->
          <div *ngIf="selectedMenu === 5" class="col-content">
            <managers-agreements-detail-authorized-waste
              [acuerdoIndirectoInfo]="acuerdoInfo">
            </managers-agreements-detail-authorized-waste>
          </div>

          <!-- 6. ÁMBITO GEOGRÁFICO -->
          <div *ngIf="selectedMenu === 6" class="col-content">
            <managers-agreements-detail-geographic-scope
              [acuerdoIndirectoInfo]="acuerdoInfo"
              [soloLectura]="!canEditGeneralSections()">
            </managers-agreements-detail-geographic-scope>
          </div>
     <!-- 8. POSEEDORES CON ACUERDO -->
          <div *ngIf="selectedMenu === 8 && (this.acuerdoIndirectoInfo?.estado?.id === 5 ||  this.acuerdoIndirectoInfo?.estado?.id === 6)" class="col-content">
            <managers-agreements-holders
              [acuerdoIndirectoInfo]="acuerdoInfo"
              (refrescarAdheridoEvent)="refrescar()">
            </managers-agreements-holders>
          </div>
          <!-- 7. DOCUMENTOS -->
          <div *ngIf="selectedMenu === 7 && this.acuerdoIndirectoInfo?.estado?.id !== 1 && this.acuerdoIndirectoInfo?.estado?.id !== 2" class="col-content">
            <managers-agreements-detail-documents
              [acuerdoIndirectoInfo]="acuerdoIndirectoInfo"
              [canUpload]="canUploadDocumentSection()"
              [canDelete]="canDeleteDocumentSection()"
              (refrescarAdheridoEvent)="refrescar()">
            </managers-agreements-detail-documents>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="button-actions">
        <button type="button" *ngIf="canAccessCancelar()" (click)="buttonCancelar()" class="btn btn-outline-primary">
          <div class="text-icon">Cancelar</div>
        </button>
        <button type="button" *ngIf="canAccessVolver()" (click)="buttonVolver()" class="btn btn-outline-primary">
          <div class="text-icon">Volver</div>
        </button>
        <button type="button" *ngIf="canAccessAnteriorAll(selectedMenu) && selectedMenu !== 1"
          class="btn btn-outline-primary" (click)="anterior()">
          <div class="text-icon"><span class="icon-arrow-left"></span>Anterior</div>
        </button>
        <button type="button" *ngIf="canAccessContinuarAll(selectedMenu) || canAccessGuardar(selectedMenu)"
          class="btn btn-outline-primary" (click)="controlAccionsWizard(selectedMenu)">
          <div class="text-icon">{{continuarName(selectedMenu)}}<span *ngIf="continuarName(selectedMenu)!='Guardar'"
              class="icon-arrow-right"></span></div>
        </button>
        <button type="button" *ngIf="canAccessFinalizar(selectedMenu) && selectedMenu === 6"
          class="btn btn-outline-primary" (click)="finalizar()">
          <div class="text-icon">Finalizar</div>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- FIN CONTENIDO - FICHA -->

